import { z } from "zod"
import { Errors } from "../../errors"

export const VerifyBrianEmployeeSchema = z.strictObject({
  email: z.string().trim().toLowerCase().email(Errors.EMAIL_INVALID),
  password: z
    .string({ error: Errors.PASSWORD_REQUIRED })
    .min(1, { message: Errors.PASSWORD_REQUIRED }),
})
